export const FIELD_LABELS = {
    filename: "EVENT ID",
    method: "METHOD",
    mode: "MODE",
    trigtime: "TRIGGER TIME",
    trigutc: "TRIGGER UTC",
    detectors: "TRIGGERED DETECTORS",
    n0: "N0",
    n1: "N1",
    n2: "N2",
    n3: "N3",
    n4: "N4",
    n5: "N5",
    n6: "N6",
    n7: "N7",
    n8: "N8",
    n9: "N9",
    na: "Na",
    nb: "Nb",
    duration: "DURATION",
    hr_25: "HR 25",
    hr_50: "HR 50",
    hr_75: "HR 75",
    hr_300: "HR 300",
    trig_gr: "TRIGGER GRADE",
    sfl_gr: "SFL GRADE",
    transnt_gr: "TRANSNT GRADE",
    par_gr: "PAR GRADE",
    trig_id: "TRIG ID",
    sfl_id: "SFL ID",
    transnt_id: "TRANSNT ID",
    sgr_prob: "SGR Probability",
    sgrb_prob: "SGRB Probability",
    lgrb_prob: "LGRB Probability",
    sfl_prob: "SFLARE Probability",
    tgf_prob: "TGF Probability",
    transnt_prob: "TRANSNT Probability",
    lpar_prob: "LOCLPAR Probability",
    dpar_prob: "DISTPAR Probability",
    no_evaluation: "NO EVALUATION",
}

export enum FIELD {
    EVENT_ID = "filename",
    METHOD = "method",
    MODE = "mode",
    TRIGTIME = "trigtime",
    TRIGUTC = "trigutc",
    DETECTORS = "detectors",
    N0 = "n0",
    N1 = "n1",
    N2 = "n2",
    N3 = "n3",
    N4 = "n4",
    N5 = "n5",
    N6 = "n6",
    N7 = "n7",
    N8 = "n8",
    N9 = "n9",
    Na = "na",
    Nb = "nb",
    DURATION = "duration",
    HR_25 = "hr_25",
    HR_50 = "hr_50",
    HR_75 = "hr_75",
    HR_300 = "hr_300",
    TRIG_GRADE = "trig_gr",
    SFL_GRADE = "sfl_gr",
    TRANSNT_GRADE = "transnt_gr",
    PAR_GRADE = "par_gr",
    TRIG_ID = "trig_id",
    SFL_ID = "sfl_id",
    TRANSNT_ID = "transnt_id",
    SGR = "sgr_prob",
    SGRB = "sgrb_prob",
    LGRB = "lgrb_prob",
    SFLARE = "sfl_prob",
    TGF = "tgf_prob",
    TRANSNT = "transnt_prob",
    LOCLPAR = "lpar_prob",
    DISTPAR = "dpar_prob",
    NO_EVALUATION = "no_evaluation",
}



export enum FTYPE {
    PDF = ".pdf",
    JSON = ".json"
}

export const DATA_PATH = "tmp/";

export enum EVALUE {
    MIN = "min",
    MAX = "max"
}

const BASES = {
    //DEV: "http://localhost",
     DEV: "https://magnetars.sabanciuniv.edu",
    // DEV: "http://magnetars.sabanciuniv.edu",
    PRD: ""
}

export const BASE = BASES.DEV;